import { useRouter } from 'vue-router'

/**
 * 若有路由历史则返回上一页，否则跳转到指定页（默认首页）。
 * 解决用户直接粘贴地址进入页面时，点击返回按钮无历史可退的问题。
 */
export function useSmartBack(fallback = '/') {
  const router = useRouter()
  return () => {
    if (globalThis.history.state?.back) {
      router.back()
    } else {
      router.push(fallback)
    }
  }
}
